<template>
  <div id="login-page">
    <b-row>
      <b-col lg="7" class="">
        <div class="center-layout">
          <div style="display: flex; justify-content: center; margin-bottom: 10px;">
            <img :src="bintanLogo" height="120" width="120" style="margin: 0 auto;" alt="" />
          </div>
          <h3 class="text-center">Pemerintah Kabupaten Bintan</h3>
          <b-row class="card mt-4">
            <b-col md="12">
              <!-- <div class="d-flex justify-content-center align-items-center"></div> -->
              <h5 class="p-2">{{ $t('loginWelcome') }}</h5>
              <form v-on:submit.prevent="onSubmit">
                <b-alert variant="danger" :show="errorMsg !== null">
                  <span v-html="errorMsg"></span>
                </b-alert>
                <div class="form-group mt-4">
                  <b-form-input
                    type="text"
                    v-model="model.username"
                    class="form-control"
                    :placeholder="$t('isStaffId')"
                    id="exampleInputUsername"
                    aria-describedby="emailHelp"
                    name="username"
                    autofocus
                    v-bind:class="errors.has('username') ? 'is-invalid' : ''"
                    v-validate="'required'"
                  />
                </div>
                <div class="form-group mt-4">
                  <b-input-group class="mb-2">
                    <input
                      :type="passwordFieldType"
                      v-model="model.password"
                      class="form-control"
                      :placeholder="$t('isPassword')"
                      id="exampleInputPassword"
                      aria-describedby="emailHelp"
                      name="password"
                      autofocus
                      v-bind:class="errors.has('password') ? 'is-invalid' : ''"
                      v-validate="'required'"
                    />
                    <b-input-group-prepend v-if="passwordFieldType === 'password'" is-text>
                      <b-icon icon="eye-fill" type="password" @click="switchVisibility"></b-icon>
                    </b-input-group-prepend>
                    <b-input-group-prepend v-else is-text>
                      <b-icon
                        icon="eye-slash-fill"
                        type="password"
                        @click="switchVisibility"
                      ></b-icon>
                    </b-input-group-prepend>
                  </b-input-group>
                </div>
                <div class="form-group mt-4">
                  <b-button
                    type="submit"
                    class="text-white"
                    variant="primary"
                    block
                    :disabled="isLoading"
                  >
                    <font-awesome-icon v-if="isLoading" icon="spinner" spin></font-awesome-icon>
                    {{ $t('clickLogin') }}
                  </b-button>
                </div>
                <div class="form-group mt-4 text-right">
                  <b-button variant="link" id="show-btn" @click="$bvModal.show('bv-modal-help')"
                    ><strong>{{ $t('isForgotPassword') }}</strong></b-button
                  >
                  <b-modal centered id="bv-modal-help" hide-footer>
                    <template #modal-title> Lupa kata sandi ? </template>
                    <div class="d-block text-center">
                      <p>
                        Jika Anda lupa kata sandi Anda, harap hubungi supervisor Anda atau tim
                        backend <b>PT. Xtend Integrasi Indonesia </b> untuk menyiapkan kata sandi baru untuk akun Anda.
                      </p>
                    </div>
                  </b-modal>
                </div>
              </form>
              <div class="d-flex">
                <!-- <b-link class="px-3"
                v-for="entry in languages"
                :key="entry.title"
                @click="changeLocale(entry.language)"
              >
                {{ entry.title }}
              </b-link> -->
              </div>
            </b-col>
              <footer class="footer">
              <a href="https://xtendindonesia.co.id/" target="_blank">
                 &copy; PT Xtend Integrasi Indonesia</a
                >
              </footer>
          </b-row>
        </div>
      </b-col>
      <b-col lg="5" class="p-0 d-none d-lg-block">
        <div class="bg-side">
          <div class="tagline text-center">
            <h3 class="text-center mr-5">{{ $t('loginDesc1') }}</h3>
            <h4 class="text-center mr-5">{{ $t('loginDesc2') }}</h4>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import i18n from '../../language/internationalization';
export default {
  data() {
    return {
      errorMsg: null,
      isLoading: false,
      locale: 'en',
      bintanLogo: require('../../assets/static/bintan-logo.png'),
      model: {
        username: '',
        password: '',
      },
      passwordFieldType: 'password',
      languages: [
        { language: 'id', title: 'Bahasa Indonesia' },
        { language: 'en', title: 'English' },
      ],
    };
  },
  // watch: {
  //     'errorMsg' (value) {
  //         if (value !== null) {
  //             setTimeout(() => {
  //                 this.errorMsg = null
  //             }, 3000)
  //         }
  //     }
  // },
  mounted() {
    // this.changeLocale();
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
      localStorage.setItem('id', 'indo');
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      if (this.isLoading) {
        return false;
      }
      this.$validator.validateAll().then((res) => {
        this.$notifications.clear();
        if (res) {
          this.isLoading = true;
          this.$store
            .dispatch('account/login', {
              username: this.model.username,
              password: this.model.password,
            })
            .then(() => {
              this.$store.dispatch(
                'notification/welcome',
                this.$store.getters['account/accountData'].firstName,
              );
              this.isLoading = false;
              if (this.$route.query.redirect !== undefined) {
                this.$router.push(this.$route.query.redirect);
              } else if (
                this.$store.getters['account/accountData'].role === 'Transportation' ||
                this.$store.getters['account/accountData'].role === 'Driver'
              ) {
                this.$router.push('/vehicle');
              } else {
                this.$router.push('/dashboard');
              }
            })
            .catch((error) => {
              this.isLoading = false;
              this.errorMsg = window.serializeErrorMessage(error);
            });
        } else {
          this.errorMsg = "Username and password can't be empty";
        }
      });
    },
  },
};
</script>
<style lang="css" scoped>
.card {
  border-width: 0px;
  width: 100%;
  box-shadow: 0px 0px 1px -6px #000 !important;
}
</style>
